import { render, staticRenderFns } from "./MessageCustomer.vue?vue&type=template&id=3370be2e&"
import script from "./MessageCustomer.vue?vue&type=script&lang=js&"
export * from "./MessageCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports